import { render } from "./PPAPApplicabilitySelfInspectionDetail.vue?vue&type=template&id=8b5bbdec&scoped=true"
import script from "./PPAPApplicabilitySelfInspectionDetail.vue?vue&type=script&lang=js"
export * from "./PPAPApplicabilitySelfInspectionDetail.vue?vue&type=script&lang=js"

import "./PPAPApplicabilitySelfInspectionDetail.vue?vue&type=style&index=0&id=8b5bbdec&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b5bbdec"]])

export default __exports__